import React from 'react';

const LanguagePreview = ({ language }) => {
  const previewContent = {
    en: {
      greeting: "Welcome to Phangan Taxi",
      booking: "Book Your Ride",
      price: "Fixed Prices",
      contact: "Contact Us"
    },
    ru: {
      greeting: "Добро пожаловать в Phangan Taxi",
      booking: "Забронировать поездку",
      price: "Фиксированные цены",
      contact: "Связаться с нами"
    },
    th: {
      greeting: "ยินดีต้อนรับสู่ Phangan Taxi",
      booking: "จองรถของคุณ",
      price: "ราคาคงที่",
      contact: "ติดต่อเรา"
    }
  };

  const content = previewContent?.[language] || previewContent?.en;

  return (
    <div className="bg-secondary/50 rounded-xl p-6 border border-border">
      <h4 className="text-sm font-medium text-muted-foreground mb-4">
        Interface Preview
      </h4>
      <div className="space-y-3">
        <div className="bg-card rounded-lg p-4 border border-border">
          <p className="text-lg font-semibold text-foreground">{content?.greeting}</p>
        </div>
        
        <div className="grid grid-cols-3 gap-2">
          <div className="bg-accent/10 rounded-lg p-3 text-center">
            <p className="text-xs font-medium text-foreground">{content?.booking}</p>
          </div>
          <div className="bg-accent/10 rounded-lg p-3 text-center">
            <p className="text-xs font-medium text-foreground">{content?.price}</p>
          </div>
          <div className="bg-accent/10 rounded-lg p-3 text-center">
            <p className="text-xs font-medium text-foreground">{content?.contact}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguagePreview;